class ImageAndVideos {
    constructor(section) {
        this.section = section;
        this.sectionId = section.dataset.sectionId;
        this.modal = section.querySelector(`#mediaModal-${this.sectionId}`);
        this.mediaSwiper = null;
        this.modalSwiper = null;

        this.init();
    }

    init() {
        this.initMediaSwiper();
        this.initModalSwiper();
        this.bindEvents();
    }

    // 初始化主轮播
    initMediaSwiper() {
        const swiperEl = this.section.querySelector('.image-and-videos-swiper');
        if (!swiperEl) return;

        this.mediaSwiper = new Swiper(swiperEl, {
            slidesPerView: 4,
            spaceBetween: 16,
            slidesPerGroup: 4,
            navigation: {
                nextEl: '.image-and-videos-swiper .swiper-button-next',
                prevEl: '.image-and-videos-swiper .swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 12,
                },
                750: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 16,
                },
                990: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 16,
                }
            }
        });
    }

    // 初始化模态框轮播
    initModalSwiper() {
        if (!this.modal) return;

        const swiperEl = this.modal.querySelector('.modal-swiper');
        if (!swiperEl) return;

        this.modalSwiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            navigation: {
                nextEl: '.modal-swiper .swiper-button-next',
                prevEl: '.modal-swiper .swiper-button-prev',
            },
            keyboard: {
                enabled: true,
            },
            on: {
                slideChange: () => {
                    this.handleModalVideoAutoplay();
                }
            }
        });
    }


    // 处理模态框视频自动播放
    handleModalVideoAutoplay() {
        if (!this.modalSwiper) return;

        // 暂停所有视频
        const slides = this.modal.querySelectorAll('.modal-swiper .swiper-slide');
        slides.forEach(slide => {
            const video = slide.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        });

        // 播放当前激活的视频
        const activeSlide = this.modalSwiper.slides[this.modalSwiper.activeIndex];
        if (activeSlide) {
            const video = activeSlide.querySelector('video');
            if (video) {
                video.play().catch(err => console.log('Video play prevented:', err));
            }
        }
    }

    // 绑定事件
    bindEvents() {
        // 点击媒体项打开模态框
        const mediaItems = this.section.querySelectorAll('.media-item');
        mediaItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                this.openModal(index);
            });
        });

        // 关闭按钮
        if (this.modal) {
            const closeBtn = this.modal.querySelector('.media-modal__close');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    this.closeModal();
                });
            }

            // 点击遮罩层关闭
            const overlay = this.modal.querySelector('.media-modal__overlay');
            if (overlay) {
                overlay.addEventListener('click', () => {
                    this.closeModal();
                });
            }
        }

        // ESC键关闭模态框
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal && this.modal.classList.contains('active')) {
                this.closeModal();
            }
        });
    }

    // 打开模态框
    openModal(slideIndex = 0) {
        if (!this.modal) return;

        this.modal.classList.add('active');
        document.body.classList.add('modal-open');

        // 跳转到对应的幻灯片并播放视频
        if (this.modalSwiper) {
            this.modalSwiper.slideTo(slideIndex, 0);

            // 延迟播放视频，确保幻灯片已切换
            setTimeout(() => {
                this.handleModalVideoAutoplay();
            }, 100);
        }
    }

    // 关闭模态框
    closeModal() {
        if (!this.modal) return;

        this.modal.classList.remove('active');
        document.body.classList.remove('modal-open');

        // 暂停所有视频
        const videos = this.modal.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
        });

    }
}

// 初始化所有 Image and Videos 组件
const bootImageAndVideos = () => {
    const sections = document.querySelectorAll('.image-and-videos');
    sections.forEach(section => {
        new ImageAndVideos(section);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootImageAndVideos);
} else {
    bootImageAndVideos();
}

// Shopify 主题编辑器支持
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.image-and-videos');
        if (section) {
            new ImageAndVideos(section);
        }
    });
}

